export default [
  {
    media: { icon: 'BsTranslate', color: 'info', className: 'fs-4' },
    title: 'Multi language',
    description:
      'Та өөрийн веб сайтаа олон хэл дээр гадаад дотоодын үйлчлүүлэгчтэй хүргэх боломжтой.'
  },
  {
    media: { icon: 'LiaConnectdevelop', color: 'success', className: 'fs-5' },
    title: 'Custom Development',
    description: 'Захиалагчийн хүсэлтийн дагуу нэмэлт хөгжүүлэлт хийх боломж.'
  },
  {
    media: { icon: 'CiBoxList', color: 'warning', className: 'fs-4' },
    title: 'Бүтээгдэхүүний удирдлага',
    description:
      'All the painful or time-consuming tasks in your development workflow such as compiling the SCSS or transpiring the JS are automated.'
  },
  {
    media: { icon: 'GoPeople', color: 'primary', className: 'fs-4' },
    title: 'Хэрэглэгчийн удирдлага',
    description:
      'All the painful or time-consuming tasks in your development workflow such as compiling the SCSS or transpiring the JS are automated.'
  },
  {
    media: { icon: 'CiMonitor', color: 'danger', className: 'fs-4' },
    title: 'Контент удирдлага',
    description:
      'All the painful or time-consuming tasks in your development workflow such as compiling the SCSS or transpiring the JS are automated.'
  },
  {
    media: { icon: 'GoRepoPush', color: 'dark', className: 'fs-4' },
    title: 'Блог, Нийтлэл',
    description:
      'All the painful or time-consuming tasks in your development workflow such as compiling the SCSS or transpiring the JS are automated.'
  },
  {
    media: { icon: 'GoGraph', color: 'info', className: 'fs-4' },
    title: 'Тайлан анализ',
    description:
      'All the painful or time-consuming tasks in your development workflow such as compiling the SCSS or transpiring the JS are automated.'
  },
  {
    media: {
      icon: 'GoRepoLocked',
      color: 'success',
      className: 'fs-4'
    },
    title: 'Аюулгүй байдал, Нууцлал',
    description:
      'All the painful or time-consuming tasks in your development workflow such as compiling the SCSS or transpiring the JS are automated.'
  },
  {
    media: { icon: 'MdHelpCenter', color: 'warning', className: 'fs-4' },
    title: 'Тусламж, засвар үйлчилгээ',
    description:
      'All the painful or time-consuming tasks in your development workflow such as compiling the SCSS or transpiring the JS are automated.'
  },
  {
    media: { icon: 'TbSeo', color: 'primary', className: 'fs-4' },
    title: 'SEO & Social integration',
    description:
      'All the painful or time-consuming tasks in your development workflow such as compiling the SCSS or transpiring the JS are automated.'
  },
  {
    media: { icon: 'BiCloudDownload', color: 'danger', className: 'fs-4' },
    title: 'API first',
    description:
      'All the painful or time-consuming tasks in your development workflow such as compiling the SCSS or transpiring the JS are automated.'
  },

  {
    media: {
      icon: 'BsFillClipboardPlusFill',
      color: 'info',
      className: 'fs-4'
    },
    title: 'Нэмэлт интеграцууд',
    description:
      'All the painful or time-consuming tasks in your development workflow such as compiling the SCSS or transpiring the JS are automated.'
  }
];
